import React from 'react';

const Magnifier = ({ svgRef, title, ...props }) => (
  <svg xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 20 20" width="1em" height="1em" ref={svgRef} {...props}>
    <title>{title}</title>
    <defs>
      <path id="Magnifier_a" d="M1028.3 267.58h-.91l-.32-.31a7.43 7.43 0 1 0-.8.8l.3.32v.9l5.73 5.71 1.7-1.7zm-6.87 0a5.14 5.14 0 1 1-.01-10.28 5.14 5.14 0 0 1 .01 10.28z" />
    </defs>
    <use fill="currentColor" xlinkHref="#Magnifier_a" transform="translate(-1014 -255)" />
  </svg>
);

export default Magnifier;



// WEBPACK FOOTER //
// ./src/common/icons/Magnifier.js